module.exports = __webpack_public_path__ + "img/star.7af2e1f4.svg";